import { Configuration, InteractionStatus, PublicClientApplication } from "@azure/msal-browser";
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import 'react-tooltip/dist/react-tooltip.css';
import AuthHandle from "./AuthHandle";
import { InboxMessageProvider } from "./Provider/InboxMessageContext";
import { loginRequest, msalConfig } from "./authConfig";



export default function App() {
	const { instance, inProgress } = useMsal();
	const [token, setToken] = useState<string>();
	const isAuthenticated = useIsAuthenticated();
	const msalInstance = new PublicClientApplication(msalConfig as Configuration);

	const accounts = msalInstance.getAllAccounts();

	// eslint-disable-next-line no-mixed-operators
	if (accounts.length > 0 || inProgress === InteractionStatus.None && !isAuthenticated) {

		try {
			if (accounts.length > 0) {
				instance
					.acquireTokenSilent({
						scopes: [`${process.env.REACT_APP_SCOPE}`],
						account: accounts[0],
						// prompt: "none",
					})
					.then((response) => {
						setToken(response.accessToken);
					});
			} else {
				const login = async () => {
					await instance.loginRedirect(loginRequest)
						.then(async (rs: any) => {
							instance
								.acquireTokenSilent({
									scopes: [`${process.env.REACT_APP_SCOPE}`],
									account: rs.account,
								})
								.then((response) => {
									setToken(response.accessToken);
								})
								.catch(() => {
								});
						})
						.catch(() => {
						});
				};
				login();
			}
		} catch { }
	}

	if (!token) {
		return null;
	}

	return (
		<AuthenticatedTemplate>
			<InboxMessageProvider>
				<AuthHandle token={token} />
			</InboxMessageProvider>
		</AuthenticatedTemplate>
	);
}
